<template>
  <div>
    <cbr-header 
      v-if="!this.$route.params.portalUuid" 
      :class="$style.mask">
      <cbr-logo 
        slot="logo" 
        :src="'/assets/gls_logo.png'" 
        position="left" />
    </cbr-header>

    <cbr-solo-map 
      :show="true" 
      :class="$style.mapClass" />

    <cbr-footer :class="$style.footerClass" />
  </div>
</template>

<script>
import CbrSoloMap from '../components/CbrSoloMap.vue'
import CbrHeader from '../components/CbrHeader.vue'
import CbrFooter from '../components/CbrFooter.vue'
import CbrLogo from '../components/CbrLogo.vue'
import { mapState } from 'vuex'

export default {
  components: {
    CbrSoloMap,
    CbrHeader,
    CbrFooter,
    CbrLogo
  },
  computed: {
    ...mapState('config', ['identifier', 'config'])
  },
  methods: {
    getHeight() {
      if (window.screen.width <= 600) {
        return window.screen.height
      } else {
        return window.screen.height - 300
      }
    },
    getWidth() {
      return window.screen.width
    }
  }
}
</script>
<style module>
.mask {
  z-index: 1;
}

.mapClass {
  top: 90px;
  height: calc(100% - 157px);
  z-index: 0;
  @media (max-width: 600px) {
    top: 40px;
    height: calc(100% - 107px);
  }
}

.footerClass {
  z-index: 0;
  position: fixed;
  bottom: 0px;
  margin-top: 0px;
}
</style>


// WEBPACK FOOTER //
// client/views/MapHolder.vue